/* eslint-disable no-undef */
import Adapter from '@/services/adapter';
import useNodeUrls from '@/composables/useNodeUrls';
export default function useWPClient() {
  const urls = useNodeUrls();
  const {
    NODE_HOST
  } = storeToRefs(urls);
  return new Adapter(NODE_HOST.value);
}